const DB_NAME = 'plenoil_cache';
const STORE_NAME = 'cache_store';
const DB_VERSION = 1;

function openDB() {
	return new Promise((resolve, reject) => {
		const request = indexedDB.open(DB_NAME, DB_VERSION);
		request.onupgradeneeded = (e) => {
			const db = e.target.result;
			if (!db.objectStoreNames.contains(STORE_NAME)) {
				db.createObjectStore(STORE_NAME, { keyPath: 'key' });
			}
		};
		request.onsuccess = (e) => resolve(e.target.result);
		request.onerror = (e) => reject(e.target.error);
	});
}

export async function cacheGet(key, ttlMinutes = 15) {
	try {
		const db = await openDB();
		return new Promise((resolve) => {
			const tx = db.transaction(STORE_NAME, 'readonly');
			const store = tx.objectStore(STORE_NAME);
			const request = store.get(key);
			request.onsuccess = () => {
				const entry = request.result;
				if (!entry) return resolve(null);

				const elapsed = Date.now() - entry.timestamp;
				if (elapsed > ttlMinutes * 60 * 1000) return resolve(null);

				resolve({ data: entry.data, timestamp: entry.timestamp });
			};
			request.onerror = () => resolve(null);
		});
	} catch (e) {
		return null;
	}
}

export async function cacheSet(key, data) {
	try {
		const db = await openDB();
		return new Promise((resolve) => {
			const tx = db.transaction(STORE_NAME, 'readwrite');
			const store = tx.objectStore(STORE_NAME);
			store.put({ key, data, timestamp: Date.now() });
			tx.oncomplete = () => resolve(true);
			tx.onerror = () => resolve(false);
		});
	} catch (e) {
		return false;
	}
}